<template>
	<v-spacer />
</template>

<script>
export default {
	name: 'KSpacer'
};
</script>